module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoadingStuff) ? _c('div', {
    staticClass: "text-center p-3"
  }, [_c('loader')], 1) : _c('div', [_c('h3', {
    staticClass: "mt-3"
  }, [_vm._v("Product Pricing")]), _vm._v(" "), (false) ? _c('div', [_c('div', {
    staticClass: "row my-5 align-items-center"
  }, [_c('div', {
    staticClass: "col-sm-4 pt-3"
  }, [_c('checkbox', {
    attrs: {
      "name": "priceIncludeTaxes"
    },
    model: {
      value: (_vm.getSelectedEvent.isPriceIncludeTaxes),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedEvent, "isPriceIncludeTaxes", $$v)
      },
      expression: "getSelectedEvent.isPriceIncludeTaxes"
    }
  }, [_vm._v("Price include taxes")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.types) ? _c('v-select', {
    attrs: {
      "options": _vm.types,
      "label": "description",
      "placeholder": "- Select type -"
    },
    on: {
      "input": function($event) {
        return _vm.updateType(_vm.selectedPrincingType)
      }
    },
    model: {
      value: (_vm.selectedPrincingType),
      callback: function($$v) {
        _vm.selectedPrincingType = $$v
      },
      expression: "selectedPrincingType"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.selectedPrincingType && _vm.selectedPrincingType.id == 1) ? _c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [(_vm.taxes) ? _c('v-select', {
    attrs: {
      "options": _vm.taxes,
      "label": "description",
      "placeholder": "- Select tax -"
    },
    on: {
      "input": function($event) {
        return _vm.updateTaxType(_vm.getSelectedEvent.eventGenderPrices[0], _vm.getSelectedEvent.eventGenderPrices[0].vatTypeHelper)
      }
    },
    model: {
      value: (_vm.getSelectedEvent.eventGenderPrices[0].vatTypeHelper),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedEvent.eventGenderPrices[0], "vatTypeHelper", $$v)
      },
      expression: "getSelectedEvent.eventGenderPrices[0].vatTypeHelper"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.getSelectedEvent.eventGenderPrices[0].value),
      expression: "getSelectedEvent.eventGenderPrices[0].value"
    }],
    staticClass: "glued-right",
    staticStyle: {
      "width": "4rem"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.getSelectedEvent.eventGenderPrices[0].value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.getSelectedEvent.eventGenderPrices[0], "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left"
  }, [_vm._v("€")])])])])]) : _vm._e()]), _vm._v(" "), (_vm.selectedPrincingType && _vm.selectedPrincingType.id == 2) ? _c('div', {
    staticClass: "w-100"
  }, [(_vm.getSelectedEvent.eventGenderPrices && _vm.getSelectedEvent.eventGenderPrices.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getSelectedEvent.eventGenderPrices), function(pricePerPerson, index) {
    return _c('div', {
      staticClass: "col-sm-12 mt-2 bg-lighter border-light radius-normal py-2 overflow-hide"
    }, [_c('div', {
      staticClass: "row"
    }, [(_vm.getSelectedEvent.eventGenderPrices) ? _c('div', {
      staticClass: "col-sm-3"
    }, [(_vm.audienceTypes) ? _c('v-select', {
      staticClass: "w-100",
      attrs: {
        "options": _vm.audienceTypes,
        "label": "description",
        "placeholder": "- Select type -"
      },
      on: {
        "input": function($event) {
          return _vm.updateAudienceType(pricePerPerson, pricePerPerson.audienceTypeHelper)
        }
      },
      model: {
        value: (pricePerPerson.audienceTypeHelper),
        callback: function($$v) {
          _vm.$set(pricePerPerson, "audienceTypeHelper", $$v)
        },
        expression: "pricePerPerson.audienceTypeHelper"
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [(pricePerPerson.productGenderPriceComponents && pricePerPerson.productGenderPriceComponents.length > 0) ? _c('input', {
      staticClass: "w-100",
      attrs: {
        "type": "text",
        "disabled": "disabled"
      },
      domProps: {
        "value": _vm.customPerPersonTaxes(pricePerPerson.productGenderPriceComponents)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.taxes && pricePerPerson.productGenderPriceComponents && pricePerPerson.productGenderPriceComponents.length <= 0) ? _c('v-select', {
      attrs: {
        "options": _vm.taxes,
        "label": "description",
        "placeholder": "- Select tax -"
      },
      on: {
        "input": function($event) {
          return _vm.updateTaxType(pricePerPerson, pricePerPerson.vatTypeHelper)
        }
      },
      model: {
        value: (pricePerPerson.vatTypeHelper),
        callback: function($$v) {
          _vm.$set(pricePerPerson, "vatTypeHelper", $$v)
        },
        expression: "pricePerPerson.vatTypeHelper"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2 px-0"
    }, [(pricePerPerson.productGenderPriceComponents && pricePerPerson.productGenderPriceComponents.length > 0) ? _c('input', {
      staticClass: "w-100",
      attrs: {
        "type": "text",
        "disabled": "disabled"
      },
      domProps: {
        "value": _vm.customPerPersonTotal(pricePerPerson.productGenderPriceComponents) + ' €'
      }
    }) : _c('div', {
      staticClass: "d-flex w-100"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pricePerPerson.value),
        expression: "pricePerPerson.value"
      }],
      staticClass: "glued-right w-100",
      staticStyle: {
        "width": "4rem"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (pricePerPerson.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pricePerPerson, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "glued-left"
    }, [_vm._v("€")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('div', {
      staticClass: "color-1 fs-small mt-2 pointer",
      on: {
        "click": function($event) {
          return _vm.openEditPrice(pricePerPerson)
        }
      }
    }, [_c('i', {
      staticClass: "ico",
      class: {
        'ico-arrow-bottom': !pricePerPerson.editing, 'ico-arrow-top': pricePerPerson.editing
      }
    }), _vm._v(" Edit price")])]), _vm._v(" "), (index > 0) ? _c('div', {
      staticClass: "col-sm-1"
    }, [_c('div', {
      staticClass: "mt-2"
    }, [_c('i', {
      staticClass: "ico-delete fs-large medium pointer",
      on: {
        "click": function($event) {
          return _vm.removePrincingAgeRow(index)
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (pricePerPerson.editing) ? _c('div', {
      staticClass: "w-100 px-2 mx-2 py-3 w-100 mt-3 d-flex flex-column bg-lightest radius-normal border-light"
    }, [_c('split-price-editor', {
      attrs: {
        "priceObj": pricePerPerson
      }
    })], 1) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "add d-flex align-items-center pointer fs-small bold",
    on: {
      "click": _vm.addRow
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add new price\n                          ")])])])], 2) : _vm._e()]) : _c('pricingManager', {
    attrs: {
      "showHeader": false
    },
    model: {
      value: (_vm.getSelectedEvent.eventGenderPrices),
      callback: function($$v) {
        _vm.$set(_vm.getSelectedEvent, "eventGenderPrices", $$v)
      },
      expression: "getSelectedEvent.eventGenderPrices"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Age group")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Tax")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Total")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-00a2b670", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00a2b670"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventEdit/areaPrices.vue
// module id = 957
// module chunks = 0